<template>
    <div>
        <div class="ml-3 mt-0 mb-0 headline" style="margin-top: 1px !important">
            <span v-if="invoice.seller_name">{{ invoice.seller_name }}</span>
        </div>
        <div class="ml-3 comp-data mt-3 caption mb-3">
            <div v-if="invoice.seller_address">
                <span>{{ invoice.seller_address }}</span>
            </div>
            <div v-if="invoice.seller_company_number">
                {{ translations.seller_company_number }}: {{ invoice.seller_company_number }}
            </div>
            <div v-if="invoice.seller_vat_number">
                {{ translations.seller_vat_number }}: {{ invoice.seller_vat_number }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InvoiceSellerInfoBlock",
    components: {},
    props: {
        invoice: {
            type: Object,
            required: true
        },
        translations: {
            type: Object,
            required: true
        }
    },
    setup() {
        return {};
    }
};
</script>

<style scoped lang="scss">
.comp-data {
    color: var(--v-g5-base);
    line-height: 20px;
}
</style>